import StudioAPI from "../api/StudioAPI";
import {fetchProjectsBegin, fetchProjectsError, fetchProjectsSuccess} from "../actions/projects";
import {fetchProductsBegin, fetchProductsSuccess, fetchProductsError} from "../actions/products";
import {GenericThunkAction, GenericThunkDispatch, GenericThunkGetState} from "../types/Types";
import {ErrorResponse, ProjectData, ProjectDataItem, StudioResponse} from "../types/StudioAPITypes";
import {
  PRODUCT_STATUS,
  ROUTES,
  PRODUCT_FILTER_PREFIX,
  STUDIO_DISABLE_LIBRARIES_LINK,
  IMPORT_POLL_INTERVAL
} from "../utils/constants";
import {fetchProductStatus} from "./productActions";
import PollManager from "../utils/PollingManager";
import history from "../utils/history";
import {buildRoute} from "../utils/routerUtils";
const api = StudioAPI.getInstance();

export function fetchProjects(): GenericThunkAction<Promise<{} | void>> {
  clearProductFilters();
  return (dispatch: GenericThunkDispatch, getState: GenericThunkGetState) => {
    dispatch(fetchProjectsBegin());
    return api.fetchProjects()
      .then((json: StudioResponse<{}>) => {
          const response: StudioResponse<ProjectData> = <StudioResponse<ProjectData>>json;
          const data = response.data;
          dispatch(fetchProjectsSuccess(data));

          if (data.length !== 1) {
            localStorage.setItem(STUDIO_DISABLE_LIBRARIES_LINK, "false");
            return data;
          } else {
            localStorage.setItem(STUDIO_DISABLE_LIBRARIES_LINK, "true");
            history.push(buildRoute(ROUTES.PRODUCTS, {":projectId": data[0].id}));
          }
        },
        (error: ErrorResponse) => dispatch(fetchProjectsError(error))
      )
  };
}

export function fetchProject(projectId: string): GenericThunkAction<Promise<any | void>> {
  return (dispatch: GenericThunkDispatch, getState: GenericThunkGetState) => {
    dispatch(fetchProductsBegin(projectId));
    return api.fetchProject(projectId)
      .then((json: StudioResponse<{}>) => {
        dispatch(fetchProductsSuccess(json.data));
          const response: StudioResponse<ProjectDataItem> = <StudioResponse<ProjectDataItem>>json;

          // Start polling if any products are locked
          response.data.products.forEach((product) => {
            if (product.status === PRODUCT_STATUS.DUPLICATION_IN_PROGRESS || product.status === PRODUCT_STATUS.CONVERSION_IN_PROGRESS) {
              PollManager.add(PollManager.createKey(projectId, product.id), () => {
                return dispatch(fetchProductStatus(projectId, product.id));
              }, IMPORT_POLL_INTERVAL);
            } else {
              localStorage.removeItem(getLocalStoreKeyForProgress(product.id));
            }
          });

          return response.data
      },
        (error: ErrorResponse) => dispatch(fetchProductsError(error))
      )
  }
}

function clearProductFilters() {
  let i = 0;
  while (localStorage.key(i) !== null) {
    // Remove any product filters
    let key = localStorage.key(i);
    if ((key !== null) && key.startsWith(PRODUCT_FILTER_PREFIX)) {
      localStorage.removeItem(key);
    }
    else {
      i++;
    }
  }
}

const getLocalStoreKeyForProgress = (productId: string) => {
  return `STUDIO_PROGRESS_${productId}`;
};

